import * as React from 'react';

import PageWrapper from '~/common/layout/PageWrapper';
import PageContent from '~/common/layout/PageContent';
import PageContentWrapper from '~/common/layout/PageContentWrapper';

import SideMenu from '../containers/common/SideMenu';
import OrgLocationHeader from '../containers/locations/OrgLocationHeader';
import OrgLocationList from '../containers/locations/OrgLocationList';


export default function (children = null) {
  return (
    <React.Fragment>
      <PageWrapper>
        <SideMenu />
        <PageContent>
          <OrgLocationHeader />
          <PageContentWrapper>
            <OrgLocationList />
          </PageContentWrapper>
        </PageContent>
        {children}
      </PageWrapper>
    </React.Fragment>
  );
};
